import {useAppContext} from "./useAppContext";
import {contentService} from "../api/contentService";
import {ContactGroupEnumType} from "../definitions/enums";
import {ContactGroupModel} from "../models/domain/contactGroupModel";
import {useMemo} from "react";
import {useSuspenseQuery} from "@apollo/client";

export const useCustomerServiceContactGroupQuery = () => {
    const {catalogId} = useAppContext();

    const {error, data} = useSuspenseQuery(contentService.product.contactGroup, {
        errorPolicy: 'all',
        variables: {
            catalogId: catalogId,
            type: ContactGroupEnumType.SalesTeam
        }
    });

    // Create a new instance of the model with the data from the query result (contactGroup)
    const model = useMemo(() => data?.contactGroup ? new ContactGroupModel(data?.contactGroup) : undefined, [data]);

    // Return the model and the error (if any)
    return {model, error}
}